import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState, Suspense, lazy } from "react";
import { CircularProgress, withStyles } from "@material-ui/core";
import styles from "./MotivoCancelamentoStyle";
import Dialog from "../../../components/Dialog/Dialog";
import CloseIcon from "../../../components/Icon/Close";
import { Button } from "../../../components/ui/Buttons";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import MultiToggleButtons from "../../../components/Button/MultiToggleButtons";
import { findAllMotivoCancelamentoLimitadoAuditByMotivoCancelamentoLimitadoId } from "../../../services/AuditoriaService";

const Auditoria = lazy(() => import("../../../components/Auditoria/Auditoria"));
const InformacoesMotivoCancelamento = lazy(() =>
  import("./InformacoesMotivoCancelamento")
);

const MotivoCancelamentoModal = observer(
  ({
    classes,
    auditoriaStore,
    open,
    onClose,
    motivoCancelamentoSelecionado,
    openNotification,
    loadMotivosCancelamento,
  }) => {
    const [tabSelected, setTabSelected] = useState(0);

    useEffect(() => {
      auditoriaStore.auditoriaProps = {
        ...auditoriaStore.auditoriaProps,
        auditoria: "o motivo do cancelamento",
        auditoriaTela: "motivoCancelamentoLimite",
      };
    }, []);

    const isEdit = motivoCancelamentoSelecionado?.id;
    const getPageTitle = () => {
      const acao = isEdit ? "Editar" : "Novo";

      return pageConfiguracoes(`${acao} motivo do cancelamento`);
    };

    const changeTabSelected = async (tab) => {
      if (tab === 1) {
        auditoriaStore.auditoriaProps = {
          ...auditoriaStore.auditoriaProps,
          pageNumber: 0,
          lastPage: false,
          auditorias: [],
        };

        auditoriaStore.load = {
          query: findAllMotivoCancelamentoLimitadoAuditByMotivoCancelamentoLimitadoId,
          variableName: "motivoCancelamentoId",
          variableId: motivoCancelamentoSelecionado.id,
        };
        await auditoriaStore.loadAuditItems();
      }
      setTabSelected(tab);
    };

    const renderTab = () => {
      return tabSelected === 0 ? (
        <InformacoesMotivoCancelamento
          onClose={onClose}
          motivoCancelamentoSelecionado={motivoCancelamentoSelecionado}
          openNotification={openNotification}
          loadMotivosCancelamento={loadMotivosCancelamento}
        />
      ) : (
        <Auditoria />
      );
    };

    return (
      <>
        <PageTitle title={getPageTitle()} />
        <Dialog
          open={open}
          onClose={onClose}
          classes={{
            paper: classes.dialogPaper,
          }}
          fullWidth={true}
        >
          <div className={classes.modalHeader}>
            <div className={classes.titleModal}>
              {isEdit
                ? "Editar motivo cancelamento"
                : "Novo motivo cancelamento"}
            </div>
            <Button
              id='cfg-mcm-btn-fec'
              shape="circle"
              bgColor="#FB7676"
              style={{ height: 32, width: 32 }}
              onClick={onClose}
            >
              <CloseIcon />
            </Button>
          </div>
          <div className={classes.containerModal}>
            <MultiToggleButtons
              id='cfg-mcm-btn-tab'
              options={["Informações", "Auditoria"]}
              tabSelected={tabSelected}
              changeTabSelected={changeTabSelected}
              classes={{ buttonsContainer: classes.toggleButtons }}
              disabled={!motivoCancelamentoSelecionado?.id}
              posicaoDesabilitada={[1]}
            />
            <div className={classes.contentModal}>
              <Suspense fallback={<CircularProgress size={32} />}>
                {renderTab()}
              </Suspense>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
);

const MotivoCancelamentoModalWithStyles = withStyles(styles)(
  MotivoCancelamentoModal
);
export default inject("auditoriaStore")(MotivoCancelamentoModalWithStyles);
